export default "__VITE_ASSET__CzYVcQPR__"